import React, { useState } from 'react';
import { uploadEventImages } from '../../services/event';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { logout } from '../../store/thunks/authThunks';
import swal from 'sweetalert';

const AddEvent = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { id, title } = location.state || {};

  const navigate = useNavigate();
      const authToken = useSelector((state) => state.auth.token);
    
      const [files, setFiles] = useState([]);
      const [error, setError] = useState('');
      const [loading, setLoading] = useState(false);
    
      const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        validateAndSetFiles(selectedFiles);
      };
    
      const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        validateAndSetFiles(droppedFiles);
      };
    
      const validateAndSetFiles = (selectedFiles) => {
        // const uploadFiles = selectedFiles.filter(file => file.type === 'image/webp');
        const uploadFiles = selectedFiles;
        if (uploadFiles.length !== selectedFiles.length) {
          setError('Only .webp files are allowed.');
          return;
        }
    
        if (uploadFiles.length + files.length > 10) {
          setError('You can upload a maximum of 10 images.');
          return;
        }
    
        setFiles(prevFiles => [...prevFiles, ...uploadFiles]);
        setError('');
      };

      const handleLogout = () => {
          dispatch(logout());
          navigate('/login');
        };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        if (files.length === 0) {
          setError('Please select at least one .webp image.');
          return;
        }
    
        let formData = new FormData();
        formData.append('id', id);
        files.forEach(file => formData.append('images', file));
    
        setLoading(true);
        await uploadEventImages(formData, authToken.token, id)
        .then(response=>{
          swal({
              title: "Event",
              text: response?.data?.message,
              icon: "success",
              buttons: true,
          });
          setLoading(false);
          navigate('/events');
        })
        .catch(error=>{
          swal({
              title: "Event",
              text: error?.response?.data?.error,
              icon: "error",
              buttons: true,
            });
          setLoading(false);
          if(error.response?.data?.error && error.response?.data?.error.toLowerCase()==='invalid token'){
            handleLogout();
          } 
        });    
      };
    
      const handleDragOver = (e) => {
        e.preventDefault();
      };
    
      const removeImage = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
      };
    
      return (
        <div className="p-6 space-y-6 bg-white">
          {/* Breadcrumb */}
          <div className="text-sm text-gray-500">
            <span className="text-blue-600 cursor-pointer" onClick={() => navigate('/events')}>
              Events
            </span>
            &gt; {title} &gt; Add Images
          </div>
    
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold">Add Event Images (Event Name: {title})</h2>            
            <button
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
              onClick={() => navigate('/events')}
            >
              Back to List
            </button>
          </div>
    
          {/* Drag and Drop Section */}
          <div 
            onDrop={handleDrop} 
            onDragOver={handleDragOver}
            className="border-2 border-dashed border-gray-400 rounded p-8 flex flex-col items-center justify-center text-gray-500 cursor-pointer"
          >
            <p>Drag & drop .webp images here, or click to browse</p>
            <input
              type="file"
              accept=".webp"
              multiple
              onChange={handleFileChange}
              className="hidden"
              id="fileInput"
            />
            <label htmlFor="fileInput" className="mt-2 bg-blue-600 text-white px-4 py-2 rounded cursor-pointer hover:bg-blue-700 cursor-pointer">
              Browse Files
            </label>
          </div>
    
          {/* Preview Section BELOW */}
          {files.length > 0 && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {files.map((file, index) => (
                <div key={index} className="relative border rounded overflow-hidden group">
                  <img
                    src={URL.createObjectURL(file)}
                    alt={`preview-${index}`}
                    className="w-full h-40 object-cover"
                  />
                  <button
                    type="button"
                    onClick={() => removeImage(index)}
                    className="absolute top-1 right-1 bg-red-600 text-white rounded-full p-1 text-xs opacity-75 hover:opacity-100"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
    
          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}
    
          {/* Submit Button */}
          <div>
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="cursor-pointer bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 disabled:opacity-50"
            >
              {loading ? 'Uploading...' : 'Upload Images'}
            </button>
          </div>
        </div>
      );
}

export default AddEvent
